<template>
  <v-card v-resize="onResize">
    <v-card-actions>
      <v-btn class="primary" width="15%" depressed @click="updateAll(true)">
        Загружать все
      </v-btn>
      <v-btn icon class="warning" depressed @click="updateAll(false)">
        <v-icon> mdi-eraser </v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-text>
      <v-card elevation="0" id="tablecard">
        <v-data-table
          class="outlined"
          :items="goods"
          :headers="headers"
          show-select
          no-data-text="Дубликаты не найдены"
          :items-per-page="100"
          loading-text="Поиск дублей"
          :loading="isLoading"
          hide-default-footer
          @page-count="pageCount = $event"
          :page.sync="page"
          :height="wHeight"
          fixed-header
          id="table"
        >
          <!-- eslint-disable-next-line -->
          <template v-slot:item.data-table-select="{ on, item }">
            <v-simple-checkbox v-model="item.upload" v-on="on" class="ml-5" />
          </template>
          <!-- eslint-disable-next-line -->
          <template v-slot:header.data-table-select> Загружать? </template>
        </v-data-table>
      </v-card>
      <v-pagination v-model="page" :length="pageCount" :total-visible="5" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    goods: [],
    headers: [
      { text: "Название в файле", sortable: true, value: "name" },
      { text: "КОД", sortable: true, value: "external_code" },
      {
        text: "Название существующего товара",
        sortable: false,
        value: "collision.name",
      },
    ],
    isLoading: true,
    page: 1,
    pageCount: 0,
    itemsPerPage: 100,
    wHeight: Math.ceil(window.innerHeight * 0.5) + "px",
  }),
  async beforeMount() {
    this.$emit("cant-continue", true);
    await this.prepareUpload();
    this.flattenGoods(this.$store.getters.toUploadGroups);
    this.isLoading = false;
    this.$emit("cant-continue", false);
  },
  methods: {
    ...mapActions(["prepareUpload"]),
    flattenGoods(groups) {
      for (const group of groups) {
        for (const good of group.goods) {
          if (good.collision) this.goods.push(good);
        }
        this.flattenGoods(group.child_groups);
      }
    },
    updateAll(val) {
      for (const good of this.goods) {
        good.upload = val;
      }
    },
    onResize() {
      this.wHeight = Math.ceil(window.innerHeight * 0.5) + "px";
    },
    goToStart() {
      let el = document
        .getElementById("table")
        .getElementsByClassName("v-data-table__wrapper")[0];
      el.scrollTo(0, 0);
    },
  },
  watch: {
    page() {
      this.goToStart();
    },
  },
  components: {},
  computed: {},
  mounted() {
    this.onResize();
  },
};
</script>

<style scoped>
.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}
</style>
